import { lessThanOrEqualTo } from 'ngrx-forms/validation';
import { BuildValidatorWithComparandDecorator } from './helpers';

export const LessThanOrEqualTo = BuildValidatorWithComparandDecorator<number>(
  lessThanOrEqualTo, 'DX.FORMS.VALIDATION.ERRORS.LESS_THEN_OR_EQUAL_TO'
);
